import { render, staticRenderFns } from "./sectors.vue?vue&type=template&id=5897efb7"
import script from "./sectors.vue?vue&type=script&lang=js"
export * from "./sectors.vue?vue&type=script&lang=js"
import style0 from "./sectors.vue?vue&type=style&index=0&id=5897efb7&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5897efb7')) {
      api.createRecord('5897efb7', component.options)
    } else {
      api.reload('5897efb7', component.options)
    }
    module.hot.accept("./sectors.vue?vue&type=template&id=5897efb7", function () {
      api.rerender('5897efb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menu/sectors.vue"
export default component.exports